'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /** Define button's size */
  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
  /** Swap icon and text position */
  iconPositionRight: _propTypes2.default.bool,
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  size: 'normal',
  iconPositionRight: false
};

/* Prop Receivers */
var textSizeProps = function textSizeProps(_ref) {
  var size = _ref.size,
      iconPositionRight = _ref.iconPositionRight,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.button.size[size],
      textPaddingY = _theme$reactackle$com.textPaddingY,
      textPaddingX = _theme$reactackle$com.textPaddingX;


  return (0, _styledComponents.css)(['padding:', ' ', ';order:', ';'], (0, _reactackleCore.getValueString)(textPaddingY), (0, _reactackleCore.getValueString)(textPaddingX), iconPositionRight ? '1' : '2');
};

/* Styles */
var ButtonTextStyled = exports.ButtonTextStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ButtonTextStyled'
})(['flex-grow:1;min-width:0;', ';'], textSizeProps);

ButtonTextStyled.propTypes = propTypes;
ButtonTextStyled.defaultProps = defaultProps;
ButtonTextStyled.displayName = 'ButtonTextStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-button/dist/styles/ButtonTextStyled.js
// module id = 566
// module chunks = 0